import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../../lib/auth";
import { useI18n } from "../../i18n";
import { toast } from "sonner";
import { Satellite, LogIn } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error de autenticación");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-bg opacity-40" />
      <div className="absolute top-1/3 -left-40 w-[600px] h-[600px] rounded-full bg-cyan-500/10 blur-[120px]" />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .6 }}
        className="relative glass-card chrome-border w-full max-w-md p-8">
        <Link to="/" className="flex items-center gap-3 mb-6" data-testid="login-home-link">
          <img src="/xega-logo-new.png" alt="XEGA" className="h-12 w-auto drop-shadow-[0_0_14px_rgba(0,240,255,0.5)]" style={{ imageRendering: '-webkit-optimize-contrast' }} />
          <span className="label-mono text-[10px] leading-none border-l border-white/15 pl-3">Alta Tecnología<br/>en Seguridad</span>
        </Link>
        <h1 className="font-display text-3xl chrome-text">{t("admin.login.title")}</h1>
        <form onSubmit={submit} className="mt-7 space-y-4" data-testid="login-form">
          <div>
            <label className="label-mono">{t("admin.login.email")}</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
              className="mt-2 w-full rounded-lg bg-black/50 border border-white/10 px-4 py-3 text-white focus:border-cyan-400/50" />
          </div>
          <div>
            <label className="label-mono">{t("admin.login.password")}</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
              className="mt-2 w-full rounded-lg bg-black/50 border border-white/10 px-4 py-3 text-white focus:border-cyan-400/50" />
          </div>
          <button type="submit" disabled={loading} className="btn-metal w-full" data-testid="login-submit">
            <LogIn className="w-4 h-4" /> {loading ? "..." : t("admin.login.submit")}
          </button>
          <div className="label-mono text-center mt-3">{t("admin.login.forgot")}</div>
        </form>
      </motion.div>
    </div>
  );
}
